/** Lettering the renderer draws on the map sheet, and the painted map behind the menus. */
export const map = {
  'map.furniture': 'GENERAL STAFF  ·  SITUATION MAP  ·  SECRET',
  'map.sheet': 'Sheet {n}',
  'map.scale': '{km} km',
  'map.intercepted': 'INTERCEPTED',
  'map.interceptedOp': 'INTERCEPTED · {op}',
  'map.backdrop.regions': 'The Varnian Marches|Kessel Hills|Ostmark Lowlands|Brenn Plateau',
} as const;
